import NoiseDisplay from "./NoiseDisplay";
import { sendNoise, sendMicrophonePermissionError } from "src/pods/noise";
import { useToolkitNoiseStore } from "src/pods/noise/toolkitNoiseStore";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

export default function NoiseDisplayContainer() {
  const { gain, showSensitivityInput } = useToolkitNoiseStore();

  return (
    <PresentationPage variant="noise" onRequestHide={() => dispatchToolkitReduxAction(displayClose())}>
      <NoiseDisplay
        gain={gain}
        showSensitivityInput={showSensitivityInput}
        sendNoise={(payload) => dispatchToolkitReduxAction(sendNoise(payload))}
        onPermissionError={(errorName) => dispatchToolkitReduxAction(sendMicrophonePermissionError(errorName))}
      />
    </PresentationPage>
  );
}
